import Swiper from 'swiper/dist/js/swiper.min';
import Vue from 'vue';
import PopupFullscreen from '../popup/fullscreen/popup-fullscreen';
import AnimationFade from '../../core/animation/fade/animation-fade';

export default function () {
  const facing = document.querySelectorAll('.facing-section');

  if (facing && facing.length) {
    [].slice.call(facing).forEach((elem) => {
      const objectName = elem.getAttribute('data-object');
      const object = window[`${objectName}`];
      new Vue({
        el: elem,
        delimiters: ['${', '}}'],
        components: {
          AnimationFade,
          PopupFullscreen,
        },
        data() {
          return {
            facingSection: object,
            newTitle: '',
            isMobile: window.innerWidth < 1280,
            mainSlider: null,
            thumbSlider: null,
            thumb: null,
            main: null,
            optionsMain: null,
            optionsThumb: null,
            activeTabs: null,
            popupFullOpen: false,
            tabs: null,
            facing: null,
            tabArrows: [],
            sliders: [],
            fullscreenCards: [],
            fullscreenActive: 0,
            description: '',
            currentIndex: 0,
            activeTabButton: null,
          };
        },
        mounted() {
          if (this.facingSection.title) {
            this.newTitle = this.facingSection.title;
          }
          this.tabs = this.$refs.tabs;
          this.facing = this.$refs.facing;

          window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth < 1280;
          });

          if (this.facing) {
            this.tabArrows = [].slice.call(this.facing.querySelectorAll('.facing-section__tabs-button'));
            this.tabBtns = [].slice.call(this.facing.querySelectorAll('.facing-section__tab-btn'));
            this.sliders = [].slice.call(this.facing.querySelectorAll('.facing-section__tab'));
            if (!this.facingSection.isAside && this.$refs.inlineTabs) {
              this.$refs.inlineTabs.classList.add('facing-section__tabs--top');
            }
          }
          const left = this.tabArrows.find(el => el.dataset.arrow === 'left');
          const right = this.tabArrows.find(el => el.dataset.arrow === 'right');

          if (left && right) {
            this.toggleViewArrow(left, right);
          }

          if (this.tabs) {
            Array.from(this.tabs.children).forEach((tab, index) => {
              if (tab.classList.contains('facing-section__tab-btn--active')) {
                if (index === 0) {
                  this.tabs.scrollTop = 0;
                  this.tabs.parentElement.classList.add('facing-section__tabs--top');
                }
                if (index === Array.from(this.tabs.children).length - 1) {
                  this.tabs.scrollTop = this.tabs.scrollHeight - this.tabs.offsetHeight;
                  this.tabs.parentElement.classList.add('facing-section__tabs--bottom');
                }
                this.description = this.facingSection.tabs.btns[index].description;
                this.slidersInit(this.sliders[index], index);
              }
            });
            this.tabs.addEventListener('scroll', (e) => {
              const newHeight = e.target.scrollHeight - e.target.offsetHeight;
              const newWidth = e.target.scrollWidth - e.target.offsetWidth;
              // const previous =
              // this.tabArrows.filter(itemBtn => itemBtn.dataset.arrow === 'left')[0];
              // const next =
              // this.tabArrows.filter(itemBtn => itemBtn.dataset.arrow === 'right')[0];
              if (this.facingSection.isAside) {
                if (e.target.scrollLeft === 0) {
                  e.target.parentElement.classList.remove('facing-section__tabs--bottom');
                  e.target.parentElement.classList.add('facing-section__tabs--top');
                  // previous.style.visibility = 'hidden';
                  // next.style.visibility = 'visible';
                } else if (e.target.scrollLeft === newWidth) {
                  e.target.parentElement.classList.remove('facing-section__tabs--top');
                  e.target.parentElement.classList.add('facing-section__tabs--bottom');
                  // previous.style.visibility = 'visible';
                  // next.style.visibility = 'hidden';
                } else {
                  e.target.parentElement.classList.remove('facing-section__tabs--top');
                  e.target.parentElement.classList.remove('facing-section__tabs--bottom');
                  // previous.style.visibility = 'visible';
                  // next.style.visibility = 'visible';
                }
              } else if (!this.facingSection.isAside) {
                if (e.target.scrollLeft === 0 && this.isMobile) {
                  e.target.parentElement.classList.remove('facing-section__tabs--bottom');
                  e.target.parentElement.classList.add('facing-section__tabs--top');
                } else if (e.target.scrollTop === 0 && !this.isMobile) {
                  e.target.parentElement.classList.remove('facing-section__tabs--bottom');
                  e.target.parentElement.classList.add('facing-section__tabs--top');
                } else if (e.target.scrollLeft === newWidth && this.isMobile) {
                  e.target.parentElement.classList.remove('facing-section__tabs--top');
                  e.target.parentElement.classList.add('facing-section__tabs--bottom');
                } else if ((e.target.scrollTop === (newHeight - 1)) && !this.isMobile) {
                  e.target.parentElement.classList.remove('facing-section__tabs--top');
                  e.target.parentElement.classList.add('facing-section__tabs--bottom');
                } else {
                  e.target.parentElement.classList.remove('facing-section__tabs--top');
                  e.target.parentElement.classList.remove('facing-section__tabs--bottom');
                }
              }
            });
          }

          if (this.facingSection.isAside && this.tabs.scrollWidth === this.tabs.offsetWidth) {
            this.tabs.parentElement.classList.add('facing-section__tabs--bottom');
          }

          window.addEventListener('resize', () => {
            const prevBtn = this.tabArrows.filter(itemBtn => itemBtn.dataset.arrow === 'left')[0];
            const nextBtn = this.tabArrows.filter(itemBtn => itemBtn.dataset.arrow === 'right')[0];
            const maxScrollLeft = this.tabs.scrollWidth - this.tabs.offsetWidth;
            if (!prevBtn) return;
            if (!nextBtn) return;
            if (this.tabs.scrollLeft === 0) {
              // prevBtn.style.visibility = 'hidden';
              this.tabs.parentElement.classList.add('facing-section__tabs--top');
            } else {
              // prevBtn.style.visibility = 'visible';
              this.tabs.parentElement.classList.remove('facing-section__tabs--top');
            }
            if (this.tabs.scrollLeft === maxScrollLeft) {
              // nextBtn.style.visibility = 'hidden';
              this.tabs.parentElement.classList.add('facing-section__tabs--bottom');
            } else {
              // nextBtn.style.visibility = 'visible';
              this.tabs.parentElement.classList.remove('facing-section__tabs--bottom');
            }
          });

          if (this.tabArrows.length !== 0) {
            const prevBtn = this.tabArrows.filter(itemBtn => itemBtn.dataset.arrow === 'left')[0];
            if (prevBtn && this.tabs.scrollLeft === 0) {
              // prevBtn.style.visibility = 'hidden';
            }
            const nextBtn = this.tabArrows.filter(itemBtn => itemBtn.dataset.arrow === 'right')[0];
            const maxScroll = this.tabs.scrollWidth - this.tabs.offsetWidth;
            if (nextBtn && this.tabs.scrollLeft === maxScroll) {
              // nextBtn.style.visibility = 'hidden';
            }
            this.tabArrows.forEach((btn) => {
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                const maxScrollLeft = this.tabs.scrollWidth - this.tabs.offsetWidth;
                if (btn.dataset.arrow === 'up') {
                  this.tabs.scrollTop = 0;
                  this.tabs.parentElement.classList.remove('facing-section__tabs--bottom');
                  this.tabs.parentElement.classList.add('facing-section__tabs--top');
                } else if (btn.dataset.arrow === 'left') {
                  if (this.tabs.scrollLeft - 100 > 0) {
                    this.tabs.scrollLeft = this.tabs.scrollLeft - 100;
                    // itemBtn.style.visibility = 'visible';
                  } else {
                    this.tabs.scrollLeft = 0;
                    // btn.style.visibility = 'hidden';
                    // itemBtn.style.visibility = 'visible';
                    this.tabs.parentElement.classList.remove('facing-section__tabs--bottom');
                    this.tabs.parentElement.classList.add('facing-section__tabs--top');
                  }
                  if (this.currentIndex !== 0 && this.tabBtns.length && this.activeTabButton) {
                    this.changeTabByArrow(this.activeTabButton, this.currentIndex, false);
                  }
                  if (left && right) {
                    this.toggleViewArrow(left, right);
                    if (this.tabBtns && this.tabBtns.length && this.tabBtns[this.tabBtns.length - 1].classList.contains('facing-section__tab-btn--active')) {
                      this.tabs.parentElement.classList.add('facing-section__tabs--bottom');
                    }
                  }
                } else if (btn.dataset.arrow === 'right') {
                  if (maxScrollLeft > this.tabs.scrollLeft + 100) {
                    this.tabs.scrollLeft = this.tabs.scrollLeft + 100;
                  } else {
                    this.tabs.scrollLeft = maxScrollLeft;
                  }
                  this.changeTabByArrow(this.activeTabButton, null, true);
                  // if ((this.currentIndex !== (this.tabBtns.length - 1)) &&
                  //   this.tabBtns.length && this.activeTabButton) {
                  //   this.changeTabByArrow(this.activeTabButton, null, true);
                  // }
                  if (left && right) {
                    this.toggleViewArrow(left, right);
                  }
                  if (this.tabBtns[this.tabBtns.length - 1].classList.contains('facing-section__tab-btn--active')) {
                    const prnt = this.tabs.parentElement;
                    prnt.classList.add('facing-section__tabs--hide');
                  } else {
                    this.tabs.parentElement.classList.remove('facing-section__tabs--hide');
                  }
                } else {
                  this.tabs.scrollTop = this.tabs.offsetHeight;
                  this.tabs.parentElement.classList.add('facing-section__tabs--bottom');
                  this.tabs.parentElement.classList.remove('facing-section__tabs--top');
                }
                if (this.tabBtns[0].classList.contains('facing-section__tab-btn--active')) {
                  this.tabs.scrollLeft = 0;
                }
                if (this.tabBtns[this.tabBtns.length - 1].classList.contains('facing-section__tab-btn--active')) {
                  this.tabs.scrollLeft = this.tabs.scrollWidth - this.tabs.offsetWidth;
                }
              });
            });
          }
          if (this.tabBtns.length !== 0) {
            this.tabBtns.forEach((btn, index) => {
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.currentIndex = index;
                this.activeTabButton = this.tabBtns[this.currentIndex];
                if (left && right) {
                  this.toggleViewArrow(left, right);
                }
                this.changeTabs(btn, index);
                if (this.tabBtns && this.tabBtns.length) {
                  if (this.tabBtns[this.tabBtns.length - 1].classList.contains('facing-section__tab-btn--active')) {
                    this.tabs.parentElement.classList.add('facing-section__tabs--bottom');
                  }
                }
                if (this.tabBtns[0].classList.contains('facing-section__tab-btn--active')) {
                  this.tabs.scrollLeft = 0;
                }
                if (this.tabBtns[this.tabBtns.length - 1].classList.contains('facing-section__tab-btn--active')) {
                  this.tabs.scrollLeft = this.tabs.scrollWidth - this.tabs.offsetWidth;
                }
              });
            });
          }
          if (this.tabBtns.length) {
            this.activeTabButton = this.tabBtns.find(el => el.classList.contains('facing-section__tab-btn--active'));
          }
        },
        methods: {
          changeTabs(btn, index) {
            this.tabBtns.forEach(tmp => tmp.classList.remove('facing-section__tab-btn--active'));
            this.sliders.forEach(tmp => tmp.classList.remove('facing-section__tab--active'));
            this.sliders[index].classList.add('facing-section__tab--active');
            this.description = this.facingSection.tabs.btns[index].description;
            btn.classList.add('facing-section__tab-btn--active');
            this.slidersInit(this.sliders[index], index);
          },

          slidersInit(tab, num) {
            const mainSlider = tab.querySelector('.facing-section__main-slider');
            this.thumbSlider = tab.querySelector('.facing-section__thumb-slider');
            let sliderCounter = tab.querySelector('.sliderButtons__counter');

            this.thumb = new Swiper(this.thumbSlider, {
              slidesPerView: 'auto',
              freeMode: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
              preloadImages: false,
              lazy: true,
              resistance: true,
              resistanceRatio: 0,
              spaceBetween: 14,
              breakpoints: {
                767: {
                  spaceBetween: 7,
                },
              },
            });

            this.fullscreenCards = [];

            this.facingSection.tabs.elements[num].slider.forEach((slide) => {
              this.fullscreenCards.push(slide);
            });

            const thumbs = this.thumb;

            const options = {
              slidesPerView: 'auto',
              loop: false,
              navigation: {
                nextEl: '.sliderButtons__btn--next',
                prevEl: '.sliderButtons__btn--prev',
              },
              thumbs: {
                swiper: thumbs,
              },
              on: {
                init() {
                  sliderCounter = this.el.querySelector('.sliderButtons__counter');
                  if (sliderCounter) {
                    sliderCounter.querySelector('[data-name=activeSlide]').textContent = this.realIndex + 1;
                    sliderCounter.querySelector('[data-name=slidesLength]').textContent = this.slides.length - 2;
                  }
                  if (this.slides.length <= 1) {
                    if (this.el.querySelector('.facing-section__slider-btns')) {
                      // this.el.querySelector('.facing-section__slider-btns').style.display = 'none';
                      // this.el.nextElementSibling.style.display = 'none';
                    }
                  } else {
                    // this.el.nextElementSibling.style.display = 'block';
                  }
                  if (thumbs !== undefined) {
                    const slides = [].slice.call(thumbs.slides);
                    if (slides && slides.length) {
                      slides.forEach(tmp => tmp.classList.remove('facing-section__thumb-slide--active'));
                      slides[this.realIndex].classList.add('facing-section__thumb-slide--active');
                    }
                    thumbs.slideTo(this.realIndex);
                  }
                },
                slideChange() {
                  sliderCounter = this.el.querySelector('.sliderButtons__counter');
                  if (sliderCounter) {
                    sliderCounter.querySelector('[data-name=activeSlide]').textContent = this.realIndex + 1;
                  }
                  if (thumbs !== undefined) {
                    const slides = [].slice.call(thumbs.slides);
                    slides.forEach(tmp => tmp.classList.remove('facing-section__thumb-slide--active'));
                    slides[this.realIndex].classList.add('facing-section__thumb-slide--active');
                    thumbs.slideTo(this.realIndex);
                    thumbs.activeIndex = this.realIndex;
                    thumbs.clickedIndex = this.realIndex;
                  }
                },
              },
            };

            if (mainSlider.querySelectorAll('.swiper-slide').length === 1) {
              options.loop = false;
            }

            if (!tab.initedSwiper) {
              tab.initedSwiper = true;
              const sw = new Swiper(mainSlider, options);
              if (sw.navigation) {
                let isLast = sw.slides.length <= 1;
                let isFirst = true;
                if (sw.navigation.nextEl) {
                  const button = sw.navigation.nextEl;
                  button.addEventListener('click', () => {
                    if (isLast) {
                      this.changeTabByArrow(this.activeTabButton, this.currentIndex, true);
                    }
                    isLast = sw.isEnd;
                    isFirst = false;
                  });
                }
                if (sw.navigation.prevEl) {
                  sw.navigation.prevEl.addEventListener('click', () => {
                    if (isFirst) {
                      this.changeTabByArrow(this.activeTabButton, this.currentIndex, false);
                    }
                    isFirst = sw.isBeginning;
                    isLast = false;
                  });
                }
              }
            }
          },

          openFullPopup() {
            const popup = this.$el.querySelector('.popup-fullscreen');
            this.fullscreenActive = this.thumb.activeIndex;
            window.bodyLock.disableBodyScroll(popup);
            setTimeout(() => {
              this.popupFullOpen = true;
            }, 500);
          },
          changeTabByArrow(btn, index, next) {
            if (next) {
              if ((this.currentIndex + 1) === this.tabBtns.length) {
                this.currentIndex = 0;
              } else {
                this.currentIndex += 1;
              }
            } else if (!next) {
              if (this.currentIndex === 0) {
                this.currentIndex = this.tabBtns.length - 1;
              } else {
                this.currentIndex -= 1;
              }
            }
            this.activeTabButton = this.tabBtns[this.currentIndex];
            this.changeTabs(this.activeTabButton, this.currentIndex);
          },
          toggleViewArrow(left, right) {
            if (this.tabBtns.length) {
              left.style.visibility = (this.currentIndex === 0) ? 'hidden' : 'visible';
              right.style.visibility = (this.currentIndex === (this.tabBtns.length - 1)) ? 'hidden' : 'visible';
            }
          },
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/facing-section/facing-section.js